import { usePrismicQuery } from '@openeducation/oe-rn-components';
import { predicate } from '@prismicio/client';
import { useMemo } from 'react';

const DEFAULT_LANG = 'en-oe';

export function useLessonEvaluateDescription() {
  const query = useMemo(
    () => [
      predicate.at('my.pc-teacher-feedback.uuid', 'lesson_evaluate_tooltip'),
    ],
    []
  );

  const { results, isLoading } = usePrismicQuery(query);

  return {
    description: results?.find((result) => result.lang === DEFAULT_LANG),
    isLoading,
  };
}
